/*****************/
/* INITIAL STATE */
/*****************/
type DialogState = {
  dialog: DialogProperties | null | undefined;
};

const initialState: DialogState = {
  dialog: null,
};

/*********/
/* TYPES */
/*********/
export interface DialogProperties {
  title?: string;
  content?: any;
  actions?: any;
  dialogProps?: any;
  fullScreen?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
}

export enum DialogActionTypes {
  SHOW_DIALOG = "SHOW_DIALOG",
  HIDE_DIALOG = "HIDE_DIALOG",
}

export interface DialogAction {
  type: DialogActionTypes;
  payload?: DialogProperties;
}

/*******************/
/* ACTION CREATORS */
/*******************/
export function showDialog(payload: DialogProperties): DialogAction {
  return {
    type: DialogActionTypes.SHOW_DIALOG,
    payload,
  };
}

export function hideDialog(): DialogAction {
  return {
    type: DialogActionTypes.HIDE_DIALOG,
  };
}

/***********/
/* REDUCER */
/***********/
function dialogReducer(state = initialState, action: DialogAction): DialogState {
  switch (action.type) {
    case DialogActionTypes.SHOW_DIALOG:
      return {
        ...state,
        dialog: action.payload,
      };

    case DialogActionTypes.HIDE_DIALOG:
      return {
        ...state,
        dialog: null,
      };

    default:
      return state;
  }
}

export default dialogReducer;